export default __webpack_public_path__ + "static/media/privacy-policy.dc4755dd.pdf";